import Vue from 'vue'
import Storage from 'vue-ls'
import { Form, Button, Input, Radio, Select, Modal } from 'ant-design-vue'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import VerifyType from '@/components/verify-type'

import './css/index.less'

Vue.use(Storage)
Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Select)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(VerifyType)
